// Show header after scroll - add class to header when #main is 40% from the top of the viewport
function addClassToHeaderOnScroll() {
    var mainElement = document.getElementById('main');
    // var header = document.querySelector('header');
    var header = document.querySelector('.home header');


    if (mainElement && header) { // Check if elements exist
        window.addEventListener('scroll', function() {
            var mainElementTop = mainElement.getBoundingClientRect().top;
            var triggerPoint = window.innerHeight * 0.65; // 40% of the viewport height

            if (mainElementTop <= triggerPoint) {
                // Add class to header when #main is 40% from the top
                header.classList.add('bg-senior-light-brown', 'noise-background', 'header-scrolled');
                header.classList.remove('bg-transparent');
            } else {
                // Remove the class if #main is not within 40% from the top
                header.classList.remove('bg-senior-light-brown', 'noise-background', 'header-scrolled');
                header.classList.add('bg-transparent');
            }
        });
    }
}

// Call the function
addClassToHeaderOnScroll();

// scroll down icon
document.addEventListener('DOMContentLoaded', () => {
    const scrollLink = document.getElementById('scrollToMain');
    if (scrollLink) { // Check if the element exists
        scrollLink.addEventListener('click', (e) => {
            e.preventDefault();
            const mainElement = document.getElementById('main');
            if (mainElement) { // Check if the main element exists
                smoothScrollTo(mainElement, 600);
            }
        });
    }
});

function smoothScrollTo(target, duration) {
    const targetPosition = target.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
    const startPosition = window.pageYOffset;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, targetPosition, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
}

// homepage-fadein
document.addEventListener("DOMContentLoaded", function () {
    // Function to add the 'fade-in' class to elements
    const fadeInOnScroll = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('fade-in');
                // Optional: Unobserve the element after adding the class
                observer.unobserve(entry.target);
            }
        });
    };
  
    // Creating a new Intersection Observer instance
    const observer = new IntersectionObserver(fadeInOnScroll, {
        root: null, // relative to the viewport
        rootMargin: '0px 0px -10% 0px', // bottom margin of 10% of the viewport height
        threshold: 0 // the callback will execute every time the target meets the rootMargin criteria
    });
  
    // Targeting elements with the '.homepage-fadein' class
    const targets = document.querySelectorAll('.homepage-fadein');
  
    // Check if the targeted elements exist before observing them
    if (targets.length > 0) {
        targets.forEach(target => {
            observer.observe(target); // Observing each target
        });
    } else {
        // Log a message if no elements are found (optional)
        console.log("No elements with the class '.homepage-fadein' were found.");
    }
  });

// homepage dynamic content
document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('[data-show]');
    const contentAreas = document.querySelectorAll('.content-area');

    menuItems.forEach(item => {
        item.addEventListener('click', function() {
            // Get the identifier for the section to show
            const sectionToShow = this.getAttribute('data-show');

            // Hide all content areas
            contentAreas.forEach(area => {
                area.classList.add('hidden');
                area.classList.remove('fade-in'); // Ensure the fade-in class is removed
            });

            // Remove 'active' class from all menu items
            menuItems.forEach(menuItem => {
                menuItem.classList.remove('active', 'text-sedbergh-gold');
            });

            // Add 'active' class to the clicked menu item
            this.classList.add('active', 'text-sedbergh-gold');

            // Show the content area that matches the clicked menu item
            const matchingContentArea = document.querySelector(`.content-area[data-show="${sectionToShow}"]`);
            const dynamicToggleContentTextContent = document.querySelector(`.content-area[data-show="${sectionToShow}"] .text-content`);

            if (matchingContentArea) {
                matchingContentArea.classList.remove('hidden');
                matchingContentArea.classList.add('fade-in');
                dynamicToggleContentTextContent.classList.remove('hidden');
                dynamicToggleContentTextContent.classList.add('fade-in');
            }
        });
    });
});
